import { useContext } from "react";
import { ResolutionsContext } from "../contexts/ResolutionsContext";
import { IResolutionsContextType } from "../types/interfaces/IResolutionsContextType";

//This custom hook is responsible for consuming the resolution context.
export function useResolutionsContext(): IResolutionsContextType {
    const context = useContext(ResolutionsContext);

    if (!context) {
        throw new Error('The useResolutionsContext must be used within a ResolutionProvider.');
    }

    return context;
}